module.exports = __webpack_public_path__ + "img/T70.299e46ae.jpg";